import React from 'react';
import { styled } from '@mui/material';
import { useCobrandImages } from 'features/cobrand/hooks/useCobrandImage';

const PreviewImage = styled('img')(({ theme }) => ({
  alignSelf: 'center',
  width: '100%',
  maxWidth: '440px',
  [theme.breakpoints.up('md')]: { maxWidth: '694px' },
}));

export const AppStorePreview = () => {
  const { appPreviewImg } = useCobrandImages();

  return (
    <PreviewImage
      id="resources__app_preview"
      src={appPreviewImg}
      alt="Preview of the mobile application showing health tracking features"
    />
  );
};
